import { Component, OnInit } from '@angular/core';
import { DipStateService } from 'app/services/dip-state-service.service';
import { Router, ActivatedRoute } from '@angular/router';
import * as _ from 'lodash-es';

@Component({
    templateUrl: './referred-case-handler.component.html',
    standalone: false
})
export class ReferredCaseHandlerComponent implements OnInit {

    constructor(private state: DipStateService,
        private router: Router,
        private route: ActivatedRoute) {

    }

    ngOnInit() {
        this.route.params.subscribe((params) => {
            this.state.SalesPerson = params['salesPerson'];
            this.state.SalesReference = params['salesReference'];
            this.state.isDipJourney.next(params['isDip'] === 'true');
            let stage = 'tad_stage_info';
            if (!this.state.isDipJourney.getValue()) {
                stage = 'tad_stage_apply';
            }
            this.router.navigate(['dip', stage]);
        });
    }


}
